module.exports = __webpack_public_path__ + "static/media/CAM-04-mobile.83ebf851.webp";